<template>
  <ValidationObserver ref="cisgendered">
    <div>
      <h2 class="mb-5">
        Is the gender you identify with the same as your sex registered at
        birth?
      </h2>
    </div>
    <ValidationProvider v-slot="{ errors }" name="cisgendered" rules="required">
      <RadioButton
        v-model="cisgendered"
        @select="val => (cisgendered = val)"
        :options="options"
        mixed
        :selectedValue="cisgendered"
        :errorMessages="showValidationErrors ? errors : ''"
      />
    </ValidationProvider>

    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import RadioButton from "@/components/common/RadioButton";
import { BOOLEAN_OPTIONS } from "@/constants/common";
import {
  includePreferNotSayOption,
  getFormattedValue
} from "@/views/profile/QuestionsAndAnswers/steps/Diversity/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "Cisgendered",
  components: {
    PrimaryButton,
    RadioButton,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    isLoading: Boolean,
    userData: Object
  },
  created() {
    this.cisgendered = this.userData.cisgendered;
  },
  data() {
    return {
      showValidationErrors: false,
      cisgendered: null,
      options: includePreferNotSayOption(BOOLEAN_OPTIONS)
    };
  },
  methods: {
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.cisgendered.validate();
      if (isValid) {
        this.$emit("nextStep", {
          data: { cisgendered: getFormattedValue(this.cisgendered) },
          dataType: "mainDetails"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
